// extracted by mini-css-extract-plugin
module.exports = {"tours":"items-module--tours--2cbFD","center":"items-module--center--2xKcp"};